import React, { useState } from "react";
import EmbedContainer from "../../embed/container";
import { DEVELOPMENT } from "../../../constants";

const demos = [
  DEVELOPMENT && {
    id: 0,
    name: "Axa Building - DEV",
    brand: "mng-insurance",
    theme: "axa_building",
    token: "H7g32oFsxrfHrAzDnjYQ9ZtFhFbpzppK",
    locale: "fr",
    environment: "development",
    domain: "https://share.insurgate.test",
  },
  {
    id: 1,
    name: "Axa Building - VALIDATION",
    brand: "alpha-insurance",
    theme: "axa_building",
    token: "qDjx5XUHgyBGVc6ndGhWkYnSy112WoWM",
    locale: "fr",
    environment: "validation",
    domain: "https://share.insurgate-validation.com",
  },
  {
    id: 2,
    name: "Axa Building - STAGING",
    brand: "mng-insurance",
    theme: "axa_building",
    token: "H7g32oFsxrfHrAzDnjYQ9ZtFhFbpzppK",
    locale: "fr",
    environment: "staging",
    domain: "https://share.insurgate-staging.com",
  },
];

const AxaBuildingDemo = () => {
  const demoList = demos.filter((demo) => demo);
  const [demo, setDemo] = useState(demoList[0]);
  const [locale, setLocale] = useState(demoList[0].locale);
  return (
    <div>
      <h1>Axa Building Demo</h1>

      <div>
        <label style={{ marginRight: "10px" }}>Demo:</label>
        <select
          value={demo.id}
          onChange={(e) => setDemo(demos[e.target.value])}
        >
          {demoList.map((demo) => (
            <option value={demo.id} key={demo.id}>
              {demo.name}
            </option>
          ))}
        </select>
      </div>
      <div>
        <label style={{ marginRight: "10px" }}>Locale:</label>
        <select value={locale} onChange={(e) => setLocale(e.target.value)}>
          <option value="fr">FR</option>
          <option value="nl">NL</option>
        </select>
      </div>

      {demo && (
        <div key={`${demo.token}-${locale}`}>
          <EmbedContainer
            embedUrl={`${demo.domain}?aet=${demo.token}&brand=${demo.brand}&theme=${demo.theme}&locale=${locale}`}
            showCode={true}
            urlToShow={`${demo.domain}?aet=${demo.token}&brand=${demo.brand}&theme=${demo.theme}&locale=${locale}`}
          />
        </div>
      )}
    </div>
  );
};

export default AxaBuildingDemo;
